import { useMutation } from "@apollo/client/react";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";
import { DELETE_INVOICE_ROWS } from "../../mutations/invoices/deleteInvoiceRows";

export const useDeleteInvoiceRows = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [deleteInvoiceRows, { data, loading, error }] = useMutation(
    DELETE_INVOICE_ROWS,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch ? [] : [GET_INVOICE_LATEST_VALIDATION_RESULT],
      awaitRefetchQueries: true,
    },
  );

  return { deleteInvoiceRows, data, loading, error };
};
